
import { Component } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';



declare var $: any;


// import $ from 'jquery';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
   constructor(
    public dialog: MatDialog,
  ) {

   }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts